import * as React from 'react';
import {Button, Tooltip} from 'antd';
import locales from '../locales';

interface Props {
  disabled?: boolean;
  tooltip?: string;
  onRefresh: () => Promise<void> | void;
}

interface State {
  loading: boolean;
}

class ExchangeRateRefreshButton extends React.Component<Props, State> {
  public state: State = {loading: false};
  private unmounted = false;

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public render() {
    const {disabled, tooltip = locales.exchange_rate_refresh_tooltip} = this.props;
    const {loading} = this.state;

    return (
      <Tooltip title={tooltip}>
        <Button
          type="link"
          style={{padding: 0, marginLeft: 8}}
          disabled={disabled || loading}
          icon={'reload'}
          onClick={this.refresh}
        />
      </Tooltip>
    );
  }

  private refresh = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.state.loading || this.props.disabled) {
      return;
    }

    this.setState({loading: true});
    try {
      await this.props.onRefresh();
    } finally {
      if (!this.unmounted) {
        this.setState({loading: false});
      }
    }
  };
}

export default ExchangeRateRefreshButton;



// WEBPACK FOOTER //
// ./src/common/ExchangeRateRefreshButton.tsx